import { IWorkgroupState } from '@/store/workgroup';
import { IWorkgroupMutations } from './mutations.types';
import { IWorkgroupData } from '@/models';

export const mutations: IWorkgroupMutations = {
  SET_WORKGROUPS(state: IWorkgroupState, payload: IWorkgroupData[]): void {
    state.workgroups = payload;
  },

  ADD_WORKGROUP(state: IWorkgroupState, payload: IWorkgroupData): void {
    state.workgroups.push(payload);
  },

  UPDATE_WORKGROUP(state: IWorkgroupState, payload: IWorkgroupData): void {
    const index = state.workgroups.findIndex(
      (workgroup: IWorkgroupData) => workgroup.id === payload.id
    );

    state.workgroups.splice(index, 1, payload);
  },

  REMOVE_WORKGROUP(state: IWorkgroupState, payload: number): void {
    const index = state.workgroups.findIndex(
      (workgroup: IWorkgroupData) => workgroup.id === payload
    );

    state.workgroups.splice(index, 1);
  }
};
